module.exports = __webpack_public_path__ + "img/handcraft_mob.b51057a.webp";